/** Initials + color for support chat avatars. */

const AVATAR_PALETTE = [
  '#3b82f6',
  '#0ea5e9',
  '#14b8a6',
  '#22c55e',
  '#eab308',
  '#f97316',
  '#ef4444',
  '#a855f7',
  '#ec4899',
  '#6366f1',
];

export function avatarColorForId(id: number): string {
  const n = Math.abs(Number(id) || 0);
  return AVATAR_PALETTE[n % AVATAR_PALETTE.length];
}

export function avatarInitials(opts: {
  firstName?: string | null;
  username?: string | null;
  userId?: number | null;
  displayName?: string | null;
  support?: boolean;
}): string {
  const display = (opts.displayName || '').trim();
  if (display) {
    const parts = display.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return display.slice(0, 2).toUpperCase();
  }
  const name = (opts.firstName || '').trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  }
  const un = (opts.username || '').trim().replace(/^@/, '');
  if (un) return un.slice(0, 2).toUpperCase();
  if (opts.userId) return String(opts.userId).slice(-2);
  if (opts.support) return 'S';
  return '?';
}
